import { HOME_QUICK_GROUP_FILTERS, HOME_QUICK_PERSON_LABELS } from "../lib/home-quick-search";
import { ADMIN_KARIN_SUBTYPE_FILTER_OPTIONS, type AdminKarinSubtypeFilter } from "./admin-list-filter";

export function AdminQuickSearchChips({
  keyword,
  karinSubtype,
  onKeyword,
  onKarinSubtype,
  onPersonQuickPick,
  onGroupQuickPick,
}: {
  keyword: string;
  karinSubtype: AdminKarinSubtypeFilter;
  onKeyword: (next: string) => void;
  onKarinSubtype: (next: AdminKarinSubtypeFilter) => void;
  onPersonQuickPick?: (name: string, nextKeyword: string) => void;
  onGroupQuickPick?: (label: string, nextKeyword: string) => void;
}) {
  const q = keyword.trim();

  return (
    <div className="admin-quick-search" style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--line)" }}>
      <div className="row home-chip-label-row" style={{ marginBottom: 4 }}>
        <div className="home-chip-label">出演者ですぐ探す（宮本佳林以外はJ.P ROOM）</div>
      </div>
      <div className="row home-chips" style={{ marginBottom: 6 }}>
        {HOME_QUICK_PERSON_LABELS.map((name) => (
          <button
            key={name}
            type="button"
            className={`chip${q === name ? " active" : ""}`}
            onClick={() => {
              const next = q === name ? "" : name;
              if (onPersonQuickPick) onPersonQuickPick(name, next);
              else onKeyword(next);
            }}
          >
            {name}
          </button>
        ))}
      </div>
      <div className="row home-chip-label-row" style={{ marginTop: 4, marginBottom: 4 }}>
        <div className="home-chip-label">グループですぐ探す（H!P予定管理）</div>
      </div>
      <div className="row home-chips" style={{ marginBottom: 10 }}>
        {HOME_QUICK_GROUP_FILTERS.map((g) => (
          <button
            key={g.groupCode}
            type="button"
            className={`chip${q === g.label ? " active" : ""}`}
            onClick={() => {
              const next = q === g.label ? "" : g.label;
              if (onGroupQuickPick) onGroupQuickPick(g.label, next);
              else onKeyword(next);
            }}
          >
            {g.label}
          </button>
        ))}
        <button type="button" className="chip" onClick={() => onKeyword("")}>
          検索クリア
        </button>
      </div>
      <div className="row home-chip-label-row" style={{ marginBottom: 4 }}>
        <div className="home-chip-label">宮本佳林の予定タイプ</div>
      </div>
      <div className="row home-chips">
        {ADMIN_KARIN_SUBTYPE_FILTER_OPTIONS.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            className={`chip${karinSubtype === value ? " active" : ""}`}
            onClick={() => onKarinSubtype(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
